import RoundCount from 'Components/RoundCount';
import { Drop, Layer } from 'grommet';
import { Bell } from 'lucide-preact';
import { memo } from 'preact/compat';
import { useRef, useState } from 'preact/hooks';

import { useUnreadAnnouncementsCount } from '@/hooks/announcements';
import { useShouldBellRing, useUnreadBellNotificationCount } from '@/hooks/notifications';

import { useIsMobileLayout } from '../LayoutDetector/hooks';
import Notifications from './Notifications';
import style from './style.scss';

const BellNotifications = () => {
  const isMobile = useIsMobileLayout();
  const [showList, setShowList] = useState(false);
  const { data: unreadAnnouncements } = useUnreadAnnouncementsCount();
  const { data: unreadNotifications } = useUnreadBellNotificationCount();
  const unread = (unreadNotifications ?? 0) + (unreadAnnouncements ?? 0);
  const ref = useRef();
  const bellRef = useRef(null);
  const shouldBellRing = useShouldBellRing(unread, bellRef);

  const toggleHandler = () => {
    setShowList(!showList);
  };

  return (
    <div ref={ref}>
      <button
        type="button"
        onMouseDown={toggleHandler}
        disabled={showList}
        className="preflight preflight-button relative flex size-7 items-center justify-center text-stone-500 hover:text-stone-900"
      >
        <div
          ref={bellRef}
          className={unread > 0 && shouldBellRing ? 'animate-[ringingBell_2s_1s_ease-in-out] [transform-origin:50%_0]' : ''}
        >
          <Bell className="preflight preflight-svg size-5 mobile:size-[22px] mobile:text-white" />
        </div>
        <span className="sr-only">Notifications</span>
        {unread > 0 && (
          <RoundCount count={unread} className="absolute -right-1 -top-1 h-4 w-4 bg-[#ECF389] !text-stone-900" />
        )}
      </button>

      {showList &&
        (isMobile ? (
          <Layer plain fill margin={{ horizontal: '15px' }} onEsc={toggleHandler} onClickOutside={toggleHandler}>
            <div className="h-[min(600px,80vh)] w-[calc(100vw-30px)]">
              <Notifications className="rounded-lg shadow-xl" />
            </div>
          </Layer>
        ) : (
          ref.current && (
            <Drop
              align={{ top: 'bottom', right: 'right' }}
              target={ref.current}
              elevation="xlarge"
              className={style.bellDropContainer}
              plain
              round={false}
              stretch
              onEsc={toggleHandler}
              onClickOutside={toggleHandler}
            >
              <div className="h-[min(600px,80vh)] w-[min(355px,calc(100vw-20px))]">
                <Notifications />
              </div>
            </Drop>
          )
        ))}
    </div>
  );
};

export default memo(BellNotifications);
